var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.windowClass},[_c('v-container',[_vm._v(" Dashboard here ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }